export const urlOpen=(url:string)=>{
        if (url) {
            window.open(url)
        }
        return null;
    
}